// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tdUg","col":"styles_col__12dU6"};